import React, { useMemo } from 'react';
import {
  RightContainer,
  WebGameColumn,
  WebGameColumnInner,
  WebGameMainCont,
} from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { GameMain } from '../main';

import { useDemoSwitcher } from '../../hooks';
import LeftColumn from '../../containers/common/leftColumn';
import { globalTranslationKeys } from '../../enums';
import {
  BetHistoryWrapper,
  LiveBetsWrapper,
  PopupsWrapper,
  TopAndCurrentWinnersWrapper,
} from '../../containers/common';
import playForRealPopupImg from '../../assets/images/core/play-for-real-popup.png';
import logoImage from '../../assets/images/logo.png';

export const WebMainWrapper = observer(() => {
  const { demoSwitcherAdditionalFunction } = useDemoSwitcher();

  const rightContainerTabs = useMemo(
    () => [
      { name: globalTranslationKeys.LiveBets },
      { name: globalTranslationKeys.History, isBetHistory: true },
      { name: globalTranslationKeys.TopWinners },
    ],
    []
  );

  const rightContainerTabsContainers = useMemo(
    () => [
      <LiveBetsWrapper />,
      <BetHistoryWrapper />,
      <TopAndCurrentWinnersWrapper isTopWinners />,
    ],
    []
  );

  return (
    <WebGameMainCont
      isShowIconTag
      playForRealPopupImgSrc={playForRealPopupImg}
      demoSwitcherAdditionalFunction={demoSwitcherAdditionalFunction}
      lobbyLogoImageSrc={logoImage}
      isShowBogLineLobby
    >
      <LeftColumn />
      <WebGameColumn position='center'>
        <WebGameColumnInner position='center'>
          <GameMain />
        </WebGameColumnInner>
        <PopupsWrapper />
      </WebGameColumn>
      <RightContainer
        hasFreeBets
        tabs={rightContainerTabs}
        onTabChange={() => {}}
        headerNames={['id', 'amount']}
        demoSwitcherAdditionalFunction={demoSwitcherAdditionalFunction}
        setWinColor
        tabContainers={rightContainerTabsContainers}
        userImageSrc=''
        hasAvatarsBlock
        hasChat
      />
    </WebGameMainCont>
  );
});
